import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const CHECKBOX_CLASS_NAME = 'Checkbox';
export const CHECKBOX_CLASS_SLOTS = ['root'] as const;

export type CheckboxClassSlot = typeof CHECKBOX_CLASS_SLOTS[number];

export interface CheckboxClasses {
	root: string;
}

export type CheckboxClassKey = keyof CheckboxClasses;

export const getCheckboxUtilityClass = (slot: string) =>
	generateUtilityClass(CHECKBOX_CLASS_NAME, slot);

export const checkboxClasses: CheckboxClasses = generateUtilityClasses(
	CHECKBOX_CLASS_NAME,
	['root'],
);

export default checkboxClasses;
